module.exports = __webpack_public_path__ + "static/media/process-saving.5d8be9e0.svg";